const tp_cookie = (function () {
    return {
        init: function () {
            this.handCookie();
        }, handCookie: function () {
            const cookie_bar = document.getElementById("tp_cookie");
            const previewBarIframe = document.querySelector('#preview-bar-iframe');
            if (!cookie_bar) return;
            if (!window.getCookie("tp_cookie_bar")) {
                console.log(previewBarIframe);
                if (previewBarIframe) {
                    setTimeout(function () {
                        previewBarIframe.style.setProperty('display', 'none', 'important');
                    }, 1000);
                }
                cookie_bar.classList.remove("hidden");
            }
            document
                .querySelectorAll("#tp_cookie .cookie-dismiss")
                .forEach((closeCookie) => {
                    closeCookie.addEventListener("click", (e) => {
                        e.preventDefault();
                        const target = e.currentTarget;
                        target.closest("#tp_cookie").remove();
                        if (previewBarIframe) {
                            setTimeout(function () {
                                previewBarIframe.style.setProperty('display', 'block', 'important');
                            }, 500);
                        }
                        window.setCookie("tp_cookie_bar", "dismiss", 30);
                    }, false);
                });
        }
    }
})();
document.addEventListener("DOMContentLoaded", function() {
    tp_cookie.init();
});